import { Stack, Box, Text, Spinner } from '@chakra-ui/react'
import { InfoSearchBar } from '../../components/common/InfoSearchBar'
import { ClubResults } from '../../components/SearchInfo/ClubResults'
import ErrorPage from '../error-page'
import { useEffect } from 'react'
import useGetClubs from 'src/hooks/SearchInfo/useGetClubs'
import useInput from 'src/hooks/useInput'
import styled from 'styled-components'
import { colors } from 'src/common/colors'

export default function SearchClubInfo() {
    const [search, handleSearch, setSearch] = useInput('')
    const { getClubs, clubError, clubSearchResults } = useGetClubs()

    useEffect(() => {
        if (search) {
            getClubs(search)
        }
    }, [search])

    return (
        <Container>
            <Stack width='100%'>
                <Box height='201px'>
                    <Text marginBottom='32px' fontSize='22px' color={colors.darkBlue} fontFamily='KFAGothicBold'>클럽 조회</Text>
                    <InfoSearchBar placeholder='검색하고 싶은 클럽을 입력해 주세요.' value={search} onChange={(e) => setSearch(e.target.value)} marginBottom='84px' />
                </Box>
                {(clubSearchResults && clubSearchResults.content.length > 0 && search !== '') ?
                    <ClubResults results={clubSearchResults.content} />
                    :
                    <Box>
                        <Box className='results-header'>
                            <Text fontFamily='KFAGothic' fontWeight='400' fontSize='18px' color={colors.darkBlue} marginBottom='18px'>검색 결과</Text>
                        </Box>
                        {(clubSearchResults?.content.length === 0 && search) ?
                            <Text fontSize='13px' color={colors.darkBlue} opacity='0.63'>입력하신 클럽은 존재하지 않습니다.</Text>
                            :
                            (search === '') ?
                                <Text fontSize='13px' color={colors.darkBlue} opacity='0.63'>검색 후 결과를 확인해 보세요!</Text>
                                :
                                clubError ?
                                    <Box>
                                        <ErrorPage />
                                    </Box>
                                    :
                                    <Box>
                                        <Spinner />
                                    </Box>
                        }
                    </Box>
                }
            </Stack>
        </Container>
    )

}

const Container = styled.div`
    width: calc(100vw - 506px);
    min-width: 850px;
    margin-right: 92px;
    margin-bottom: 50px;
  `